import { RouteRecordRaw } from "vue-router";

const ReportsPage = () => import("@/pages/reports/ReportsPage.vue");

const routes: RouteRecordRaw = {
  name: "reports",
  path: "/reports/:customerId",
  component: ReportsPage,
  props: true,
  meta: {
    authenticated: true,
    permissions: ["reporting_report_builder"],
    breadcrumbs: [{ label: "Reporting" }],
  },
  children: [
    {
      name: "customReports",
      path: "custom/:sub?",
      redirect: (to) => {
        return {
          name: "reportBuilderDashboard",
          params: { customerId: to.params.customerId },
        };
      },
    },
  ],
};

export default routes;
